
export const initContext = {
    /** @type {Map<string, (widget: HTMLElement, data: any) => void>} */
    initialisers: new Map()
}


export function initAllWidget(type, callback) {
    document.querySelectorAll(`[widget-type='${type}']`).forEach((widget) => {
        initComponent(type, /** @type {HTMLElement} */(widget), callback)
    })
}

/**
 * @param {string} type
 * @param {HTMLElement} element
 * @param {(widget: HTMLElement, data: any) => void} callback
 */
export function initComponent(type, element, callback) {
    console.log("[Component] Init", { type })
    if (element.dataset.componentLoaded) {
        console.log("[Component] Already loaded", { type, element })
        return
    }
    element.dataset.componentLoaded = "1"
    let rawData = getData(element, type);
    const data = rawData ? JSON.parse(rawData) : {}
    callback(element, data)
}

/**
 * @param {HTMLElement} element
 * @param {string} type
 */
function getData(element, type) {
    // component-data-model at asp dotnet tag helper
    let rawData = element.dataset.model ?? null;
    if (!rawData) {
        const widgetRawData = element.getAttribute("widget-data");
        if (widgetRawData) {
            console.warn(`[Widget] ${type} is not using component-data-model attribute`)
            rawData = widgetRawData;
            element.removeAttribute("widget-data");
        }
    }
    else {
        delete element.dataset.model;
    }
    if (!rawData) {
        // console.warn(`[Component] ${type} has no component-data-model="@data" or widget-data`);
    }
    return rawData;
}